<template>
  <header class="Head">
    <div class="wrapper">
      <div class="Head__inner">
        <nav class="Head__layout Nav Nav_desktop">
          <Logo :logo="{ to: logo.to, image: logo.image.header }" />

          <ul class="Nav__menu Menu">
            <slot name="menu-main"></slot>
            <slot name="menu-additional"></slot>
          </ul>

          <slot name="socials"></slot>
          <slot name="share"></slot>
          <slot name="helpForm"></slot>
          <MobileButton />
        </nav>
      </div>
    </div>
  </header>
</template>

<script>
import { Logo, MobileButton } from "@/components/app";

export default {
  name: "Header",
  computed: {
    logo() {
      return this.$route.meta.logo;
    }
  },
  components: {
    Logo,
    MobileButton
  }
};
</script>

<style lang="scss">
@import "@/assets/_vars";

.Nav_desktop {
  & > * {
    display: flex;
    align-items: center;
  }

  .Nav__logo {
    margin: 0 20px 0 0;
  }

  @media screen and (min-width: $min-md) {
    .Nav__mobile,
    .Nav__form,
    .Nav__share {
      padding: 8px 12px;
    }

    .Nav__mobile {
      display: none;
    }
  }

  @media screen and (max-width: $max-md) {
    .Nav__share {
      span {
        display: none;
      }
    }
  }

  @media screen and (max-width: $max-sm) {
    .Nav__menu,
    .Nav__socials,
    .Nav__share {
      display: none;
    }

    .Nav__mobile,
    .Nav__form {
      padding: 12px;
    }

    .Nav__logo {
      flex: 1;
    }
  }
}

/*<Menu>*/
.Menu {
  &__main,
  &__additional {
    display: flex;
    align-items: center;
  }

  &__additional {
    flex: 1;
    justify-content: flex-end;
  }

  &__wrapper {
    display: flex;
    align-items: center;
    padding: 0 10px;
  }

  &__item {
    a {
      font-weight: $b_fw;
      color: $aux_c;
    }
  }

  &__item + &__item {
    margin: 0 0 0 15px;
  }
}

/*<Head>*/
.Head {
  .Nav__share {
    border-color: $aux_bg;

    span {
      color: $aux_c;
    }
  }
}

/*<navigation>*/
.Nav {
  display: flex;

  &__logo {
    img {
      object-fit: contain;
    }
  }

  &__menu {
    flex: 1;
    padding: 0 15px;
  }

  &__socials,
  &__share,
  &__mobile,
  &__form {
    margin: 0 0 0 15px;
  }

  &__social {
    display: flex;
    margin: 0 5px;
  }

  &__link {
    display: flex;
  }
}
</style>
